const addZeroBeforeNumber = (number) => {
  return `${number > 0 && number < 10 ? '0' : ''}${number}`
}

export default addZeroBeforeNumber
